export interface ImageLoader {}

export class ImageLoader {
  private img: HTMLImageElement;

  constructor(url: string, onLoad: (width: number, height: number) => void) {
    const img = document.createElement('img');

    img.src = url;
    img.style.position = 'absolute';
    img.style.top = '200vh';

    const onload = () => {
      onLoad(img.width, img.height);
      document.body.removeChild(img);
    };

    img.onload = onload;
    img.onerror = onload;

    this.img = img;
    this.cancel = this.cancel.bind(this);

    document.body.appendChild(img);
  }

  cancel() {
    try {
      if (this.img) {
        this.img.onload = null;
        this.img.onerror = null;

        document.body.removeChild(this.img);
      }
    } catch (err) {}
  }
}

export default ImageLoader;
